import React, { useState } from "react";
import "./style.css";
import {
  CustomLabel,
  product_static_list_data,
  regex_obj,
} from "../../Constant";
import CustomCard from "../../elements/CustomCard";
import StepperComponent from "../../component/StepperComponent";
import InputComponent from "../../component/InputComponent";
import { message } from "antd";
import { Lifetime_req_obj } from "../../RequestData";
import moment from "moment";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIsMobile } from "../../Hooks/useIsMobile";
import { getApi } from "../../service/ApiService";
import { setPlanData } from "../../Redux/CIReducer";
import { endpoints } from "../../service/endpoints";
import { decryp } from "../../Constant/Encrypt";
import { useGetDimensions } from "../../Hooks/useGetDemension";
import { HTTPRequest } from "../../utility/lib";

const AgePredict = (date) => {
  if (date == "") return "00";
  let newArr = date.split("/");
  let newDate1 = [newArr[1], newArr[0], newArr[2]];
  let new_date = newDate1.join("/");
  let newDate = moment().diff(new Date(new_date), "years");
  if (`${newDate}` == "NaN") {
    return "00";
  }
  return parseInt(newDate);
};

const LifeTimePage = () => {
  const dispatch = useDispatch();
  const isMobile = useIsMobile();
  const plandata = useSelector((state) => state.CI.plandata);
  const [userData, setUserData] = useState(plandata);
  const typeOfCalculator = useSelector((state) => state.common.type);
  const agentDataSelected = useSelector((state) => state.agData.agentData);
  useEffect(() => {}, []);
  const headerHeight = useGetDimensions("banner", 0).height;
  const REDIRECTION = process.env.REACT_APP_REDIRECTIO_BASE_URL;

  const ApiCall = async () => {
    let agevalidationOutput = validateIndividualDate();
    if (
      !ValidateAllInput() ||
      userData.pincode.length !== 6 ||
      !agevalidationOutput
    ) {
      return message.error("Please provide required information");
    }
    // if (!userData.phn) {
    //   return message.error("Please provide mobile number");
    // }
    // if (!userData.email) {
    //   return message.error("Please provide email Id");
    // }
    if (!regex_obj.pincode.test(userData.pincode)) {
      return message.error("Please provide valid pincode");
    }
    // if (!regex_obj.phoneNumberValid.test(userData.phn)) {
    //   return message.error("Please provide valid mobile number");
    // }
    // if (!regex_obj.emailValidation.test(userData.email)) {
    //   return message.error("Please provide valid email Id");
    // }
    if (userData.check === false) {
      return message.error("Please Check the checkbox");
    }
    dispatch(setPlanData(userData));
    try {
      // const res = await getApi(
      //   // `${endpoints.lifetime_pincode}${userData.pincode}`
      //    `sellonline/v1/location-details/${userData.pincode}/app/lifetime`
      // );
      const pincode_url=`sellonline/v1/location-details/${userData.pincode}/app/lifetime`;
      const res_data = await HTTPRequest.GET("pincode", pincode_url);
      let res = res_data.response;
      if (res) {
        const obj = Lifetime_req_obj({
          userData,
          type: typeOfCalculator,
          zone: res.zonecd,
          agentData: agentDataSelected,
        });
        const url = `${REDIRECTION}get-product-quote/calculate-lifetime-health-insurance/quick-quote/your-quote?q=${obj}`;
        window.location.href = url;
      }
    } catch (err) {
      console.error(err);
      message.error("something went wrong please try after sometime");
    }
  };
  const validateIndividualDate = () => {
    const age_check = userData.adultData.every(
      (ei) => Number(ei.dob) <= 65
    );
    let child_check = true;

    if (userData.child > 0 && (userData.adult > 2 || userData.child > 3)) {
      child_check = userData.childData.every((ei) => Number(ei.dob) <= 30);
    }
    return age_check && child_check;
  };
  const ValidateAllInput = () => {
    const data_A = userData.adultData.every(
      (ei) => (ei.dob !== "") & (ei.gender !== "")
    );
    const data_C = userData.childData.every(
      (ei) => (ei.dob !== "") & (ei.gender !== "")
    );
    return data_A && data_C;
  };

  const handleKeyNumber = (e) => {
    var firstDigit = e.target.value.charAt(0);

    if (
      firstDigit === "0" ||
      firstDigit === "1" ||
      firstDigit === "2" ||
      firstDigit === "3" ||
      firstDigit === "4" ||
      firstDigit === "5"
    ) {
      e.preventDefault();
      e.stopPropagation();
    } else {
      setUserData({ ...userData, phn: e.target.value });
    }
  };

  const okButtnClick = () => {
    if (!ValidateAllInput()) {
      return message.error("Please provide required information");
    }
    setUserData({ ...userData, dropDownopen: false });
  };

  const setMinusButton = (e) => {
    if (parseInt(userData.adult) + parseInt(userData.child) === 1) {
      return message.error("Need to select atleast one member");
    }
    if (e === "Adult" && parseInt(userData.adult) >= 1) {
      let newArr = [...userData.adultData];
      newArr.pop();
      setUserData({
        ...userData,
        adult: parseInt(userData.adult) - 1,
        adultData: newArr,
      });
    } else if (e === "Child" && parseInt(userData.child) >= 1) {
      let newArr = [...userData.childData];
      newArr.pop();
      setUserData({
        ...userData,
        child: parseInt(userData.child) - 1,
        childData: newArr,
      });
    }
  };

  const setPlusButton = (e) => {
    if (parseInt(userData.adult) + parseInt(userData.child) >= 8) {
      return message.error("You had selected maximum member");
    }
    const obj = { dob: "", gender: "", error: false };
    if (e === "Adult") {
      setUserData({
        ...userData,
        adult: userData.adult + 1,
        adultData: [...userData.adultData, obj],
      });
    } else if (e === "Child") {
      setUserData({
        ...userData,
        child: userData.child + 1,
        childData: [...userData.childData, obj],
      });
    }
  };

  return (
    <div
      className="bg-color py-4 font-family"
      style={{ marginTop: `${parseInt(headerHeight)}px` }}
    >
      {/* <CustomToast /> */}
      <div className="row gx-2 container">
        <div className="col-xl-8 col-12">
          <div>
            <CustomLabel font_size="26" className="my-3">
              Lifetime Quotation
            </CustomLabel>
          </div>
          <div className="col-12">
            <CustomCard>
              <div className="row mb-4">
                <div className="col-lg-6 col-12 mb-2">
                  <div>
                    <CustomLabel font_size="14">
                      No of. members to secure &nbsp;&nbsp;
                      <CustomLabel font_size="12" color="#c3c2c2">
                        Age 18 & above is Adult
                      </CustomLabel>
                    </CustomLabel>
                  </div>
                  <div className="row">
                    <div className=" col-md-6 col-6">
                      <StepperComponent
                        plusClicked={(e) => setPlusButton("Adult")}
                        minusClicked={(e) => setMinusButton("Adult")}
                        label={"Adults"}
                        value={userData.adult}
                      />
                    </div>
                    <div className=" col-md-6 col-6">
                      <StepperComponent
                        plusClicked={(e) => setPlusButton("Child")}
                        minusClicked={(e) => setMinusButton("Child")}
                        label={"Kids"}
                        value={userData.child}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 col-12">
                  <div className="row">
                    <div
                      className={
                        isMobile ? "col-md-6 col-12 mb-4" : "col-md-6 col-12"
                      }
                    >
                      <InputComponent
                        label={"Enter Age & Gender"}
                        placeholder="Enter AGE & Gender"
                        value={
                          userData.adultData.length > 0
                            ? userData.adultData[0].dob
                            : userData.childData[0].dob
                        }
                        onChange={(e) => {
                          setUserData({ ...userData, dropDownopen: true });
                        }}
                        onCancel={(e) => {
                          setUserData({ ...userData, dropDownopen: false });
                        }}
                        onOk={() => {
                          okButtnClick();
                        }}
                        onDataChange={(e, pos, type, subType) => {
                          let arr = JSON.parse(JSON.stringify(userData));
                          if (type === "Adult") {
                            arr.adultData[pos] = {
                              ...arr.adultData[pos],
                              [subType]: e[subType],
                            };
                          } else {
                            arr.childData[pos] = {
                              ...arr.childData[pos],
                              [subType]: e[subType],
                            };
                          }
                          setUserData(arr);
                        }}
                        data={userData}
                        dropdownComponent={true}
                        dropDownopen={userData.dropDownopen}
                        readOnly={true}
                      />
                    </div>
                    <div className="col-md-6 col-12">
                      <InputComponent
                        label={"Pincode"}
                        regex={regex_obj.pincode}
                        placeholder="Enter Pincode"
                        value={userData.pincode}
                        onChange={(e) => {
                          setUserData({ ...userData, pincode: e.target.value });
                        }}
                        maxLength={6}
                      />
                    </div>
                    <div className="my-3">
                      <CustomLabel
                        font_size="12"
                        font_weight="bold"
                        color="#c3c2c2"
                      >
                        Same as mentioned in Aadhaar card / Passport / Driving
                        License or any other document
                      </CustomLabel>
                    </div>
                  </div>
                </div>
                {/* <div
                  className={
                    isMobile ? "col-md-6 col-12 mb-4" : "col-md-6 col-12"
                  }
                >
                  <InputComponent
                    label={"Email"}
                    regex={regex_obj.emailValidation}
                    placeholder="Enter Your Email ID"
                    value={userData.email}
                    onChange={(e) => {
                      setUserData({ ...userData, email: e.target.value });
                    }}
                  />
                </div> */}
                {/* <div className="col-md-6 col-12">
                  <InputComponent
                    label={"Contact Number"}
                    regex={regex_obj.phoneNumberValid}
                    placeholder="Enter Your Phone Number"
                    value={userData.phn}
                    onChange={(e) => {
                      handleKeyNumber(e);
                    }}
                    extraData={true}
                    maxLength={10}
                  />
                </div> */}
              </div>
              {/* <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  onChange={() =>
                    setUserData({ ...userData, check: !userData.check })
                  }
                />
                <CustomLabel font_size="10" font_weight="normal">
                  By submitting my details, I override my NDNC registration and
                  authorize ManipalCigna Health Insurance and its
                  representatives to contact me through call, RCS, Whatsapp or
                  E-mail. I further consent to share my information on
                  confidential basis with third parties for evaluating and
                  processing this proposal.
                </CustomLabel>
              </div> */}
            </CustomCard>
            <div className="col-12 card_footer" onClick={ApiCall}>
              <CustomLabel color="white">
                {"Get Quotes".toLocaleUpperCase()}
              </CustomLabel>
            </div>
          </div>
        </div>
        <div className="col-xl-4 col-12">
          <div>
            <CustomLabel font_size="30" className="my-2">
              &nbsp;
            </CustomLabel>
          </div>
          <div className="row justify-content-center">
            {/* <div className="col-10">
              <img src="https://www.manipalcigna.com/o/com.mchi.lifetime.health/images/MCHI_Prime.png " />
            </div> */}
            <div className="col-10 mb-2">
              <div className="row mt-4">
                {product_static_list_data.map((ei) => {
                  return (
                    <React.Fragment key={`${ei}`}>
                      <div className="col-2">
                        <span className="round-img"></span>
                      </div>
                      <div className="col-10 my-2">
                        <CustomLabel font_size="12" font_weight="normal">
                          {ei}
                        </CustomLabel>
                      </div>
                    </React.Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LifeTimePage;
